import { render, staticRenderFns } from "./ProfessionalApplicationFileField.vue?vue&type=template&id=22a02e0b&scoped=true&"
import script from "./ProfessionalApplicationFileField.vue?vue&type=script&lang=js&"
export * from "./ProfessionalApplicationFileField.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalApplicationFileField.vue?vue&type=style&index=0&id=22a02e0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a02e0b",
  null
  
)

export default component.exports